import { render, staticRenderFns } from "./errorApi.vue?vue&type=template&id=946986a2"
import script from "./errorApi.vue?vue&type=script&lang=js"
export * from "./errorApi.vue?vue&type=script&lang=js"
import style0 from "./errorApi.vue?vue&type=style&index=0&id=946986a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports